import React, { Component } from 'react';
import Layout from '../../Layouts/DefaultLayout';
import { Container, Form, Row, Col, Button, Alert,Spinner } from "react-bootstrap";
import { otherApi } from "../../../api";

class ContactusViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            fname: "",
            lname: "",
            company: "",
            email: "",
            subject: "",
            purpose: "",
            message: "",
            errorField: "",
            error: "",
            sucess: "",
            isLoading:false
        }
        document.title = "Bridge Alliance | Contact Us"
    }

    componentDidUpdate = async () => {        
        if(localStorage['comingFrom'] == "logout")
        {    
            localStorage.setItem('comingFrom',''); 
            window.location.href = "/login";   
        }                    
    } 

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    _onChange = (lable, val) => {
        this.setState({
            [lable]: val
        })
    }


    _validateFileds = () => {
        let state = true;
        const {
            fname,
            lname,
            company,
            email,
            subject,
            purpose,
            message
        } = this.state;

        if (fname === "") {

        } else if (company === "") {

        } else if (email === "") {

        } else if (subject === "") {

        } else if (purpose === "") {

        } else if (message === "") {

        }

        return state;
    }

    _onSubmit = (e) => {
        e.preventDefault();
        const {
            fname,
            lname,
            company,
            email,
            subject,
            purpose,
            message
        } = this.state;

        if (this._validateFileds()) {
            let obj = {
                "firstname": fname,
                "lastname": lname,
                "company": company,
                "email": email,
                "subject": subject,
                "purpose": purpose,
                "message": message
            };
            this._submitContactUs(obj);
        }
    }

    _clearData = () => {
        this.setState({
            fname: "",
            lname: "",
            company: "",
            email: "",
            subject: "",
            purpose: "",
            message: "",
            errorField: "",
        })
    }
    _submitContactUs = async (formdata) => {
        this.setState({ isLoading: true, error: "", sucess: "" });
        const apiResponse = await otherApi.contactUs(this.props.token, formdata);
        const respJson = await apiResponse.json();
        if (apiResponse.status === 200) {
            this.setState({ isLoading: false, error: "", sucess: "Your request is submitted to admin users " }, () => this._clearData());
        } else {
            this.setState({ isLoading: false, error: respJson, sucess: "" });
        }

    }

    renderAlert = (isAlertVisible,type,msg) => {
        return (
            <Alert show={isAlertVisible} variant={type}>{msg}</Alert>
        )
    }

    render = () => {
        return (
            <Layout>
                <div className="header-bg p-4">
                    <Container>
                        <h1>Contact Us</h1>
                    </Container>    
                </div>
                <Container>
                    <Row>
                        <Col md={6} className="h-border my-4">
                            <h3 className="text-primary">Enquiry</h3>
                            <p>Share your throughts and send us your queries through this online form and we will get back to you as fast as we can. All fields are required.</p>
                            {(this.state.isLoading) && (
                                <Row>
                                    <Col md={{ span: 6, offset: 3 }}>
                                    <Spinner animation="grow" variant="primary" size="md" />
                                    </Col>
                                </Row>
                                
                            )}
                             {(this.state.isLoading===false) && (
                                this._renderForm()
                            )}
                        </Col>
                        <Col md={6}>
                            <Row>
                                <Col md={12} className="contact-info">
                                    <h3 className="text-primary my-4">Contact Information</h3>
                                    <p>For general enquiries , please reach us through the following channels.</p>
                                    <p><i className="icon icon-call text-md"></i> +65 6424 6270</p>
                                    <p><i className="icon icon-fax text-lg"></i> +65 6745 9453</p>
                                    <p><i className="icon icon-email"></i> seaenquiries@bridgealliance.com</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <h4 className="text-primary  my-4">Locate us</h4>
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.753271422331!2d103.91960331475393!3d1.3239009990344137!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1819a9ba634f%3A0xe0a50450093a0de!2sBridge+Alliance!5e0!3m2!1sen!2slk!4v1562321748959!5m2!1sen!2slk" width="100%" height="350" frameBorder="0" style={{ border: 0 }} allowFullScreen></iframe>
                                    {/*<iframe width="100%" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=350&amp;hl=en&amp;q=Chai%20Chee%20Road,%20Bridge%20Alliance%20-%20Bedok,%20ESR%20BizPark%20@Chai%20Chee,%20Singapore+(MyCompany1)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>*/}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12} className="contact-info">
                                    {/*<p><i className="icon icon-map-pin text-primary"></i> 750 Chai Chee Road, #03-02/03 Viva Business Park, Singapore 469000</p>*/}
                                       <p><i className="icon icon-map-pin text-primary"></i> 750 Chai Chee Road, #03-02/03 ESR BizPark <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; @ Chai Chee, Singapore 469000</p>
                                </Col>
                            </Row>                            
                        </Col>
                    </Row>
                </Container>
            </Layout>
        );
    };


    _renderForm = () => {
        const { error,sucess} = this.state;
        const alertType=sucess!==""?'success':"danger";
        const msg=(error!==""?error:(sucess!==""?sucess:""))

        return (
            <Form onSubmit={(e) => this._onSubmit(e)}>
                <Row>
                    <Col>
                      {(msg!=="") && (
                        this.renderAlert(true,alertType,msg)
                      )}
                        
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group >
                            <Form.Label>First Name <span className="required">*</span></Form.Label>
                            <Form.Control value={this.state.fname} type="text" onChange={(e) => this._onChange("fname", e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group >
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control value={this.state.lname} type="text" onChange={(e) => this._onChange("lname", e.target.value)} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group >
                            <Form.Label>Company <span className="required">*</span></Form.Label>
                            <Form.Control value={this.state.company} type="text" onChange={(e) => this._onChange("company", e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group >
                            <Form.Label>Email Address <span className="required">*</span></Form.Label>
                            <Form.Control value={this.state.email} type="email" onChange={(e) => this._onChange("email", e.target.value)} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group >
                            <Form.Label>Subject <span className="required">*</span></Form.Label>
                            <Form.Control value={this.state.subject} type="text" onChange={(e) => this._onChange("subject", e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group >
                            <Form.Label>Purpose of Enquiry <span className="required">*</span></Form.Label>
                            <Form.Control as="select" onChange={(e) => this._onChange("purpose", e.target.value)}>
                                <option value="">- Select -</option>
                                <option value="Enquiry">Enquiry</option>
                                <option value="Feedback">Feedback</option>
                                <option value="Sales Support">Sales Support</option>
                                <option value="Other">Other</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Form.Group >
                            <Form.Label>Message <span className="required">*</span></Form.Label>
                            <Form.Control value={this.state.message} as="textarea" rows="3" onChange={(e) => this._onChange("message", e.target.value)} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <Button variant="primary" type="submit">Submit</Button>
                    </Col>
                </Row><br />
            </Form>
        )
    }


}


/* Export Component ==================================================================== */
export default ContactusViewContainer;